export default __webpack_public_path__ + "static/worklist-3ec1d015be6eb327cedf40d4afd19faa.png";